import fp from 'lodash/fp'

const createFormatFunction = (prop) =>
  fp.map((option) => {
    const { [prop]: id, description } = option

    return {
      id,
      name: description || fp.capitalize(id),
    }
  })

export const formatCategories = createFormatFunction('category')

export const formatSubcategories = createFormatFunction('subCategory')

export const toSearchableCategory = fp.map(fp.prop('id'))
